export default __webpack_public_path__ + "static/design_mobile-bf5ba9e3b60cbdf05b4f6203464e895c.mp4";